var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StackLayout',[(_vm.caption.length > 0)?_c('AgCaption',{attrs:{"dark":_vm.dark,"noMargin":"","left":"","text":_vm.caption}}):_vm._e(),_c('ScrollView',{attrs:{"orientation":_vm.scrollOrientation}},[_c('StackLayout',{staticClass:"wrapper",attrs:{"orientation":_vm.wrapperOrientation}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }